import { StylingModel } from '../style/styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class RatingStylingModel extends CoreStylingModel {
/**
 * StylingModel options for component label
 */
label?: StylingModel;
/**
 * StylingModel options for component items
 */
item?: StylingModel;
/**
 * StylingModel options for component icon
 */
icon?: IconStylingModel;
/**
 * Means size of component items
 */
iconSize?: string;
/**
 * Css color name for selected icons
 */
filledColor?: string;
/**
 * Css color name for not selected icons
 */
emptyColor?: string;
/**
 * Constructor for generating styling options to rating component
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function RatingStylingModel_tsickle_Closure_declarations() {
/**
 * StylingModel options for component label
 * @type {?}
 */
RatingStylingModel.prototype.label;
/**
 * StylingModel options for component items
 * @type {?}
 */
RatingStylingModel.prototype.item;
/**
 * StylingModel options for component icon
 * @type {?}
 */
RatingStylingModel.prototype.icon;
/**
 * Means size of component items
 * @type {?}
 */
RatingStylingModel.prototype.iconSize;
/**
 * Css color name for selected icons
 * @type {?}
 */
RatingStylingModel.prototype.filledColor;
/**
 * Css color name for not selected icons
 * @type {?}
 */
RatingStylingModel.prototype.emptyColor;
}

